import React, { useEffect, useRef, useState } from "react";
import { DEX_NAME } from "../../../utils/constants";
import FaqCard from "./FaqCard";
import styled from "styled-components";


const TableContainer = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  gap: 1px;
  // background-color: #333;
  color: #fff;
  font-family: Arial, sans-serif;
  text-align: left;
  font-size: 14px;
  width: 100%;
`;

const Cell = styled.div<{ isHeader?: boolean }>`
  padding: 10px;
  // background-color: ${({ isHeader }) => (isHeader ? '#444' : '#222')};
  border-bottom: 1px solid #424242;
  font-weight: ${({ isHeader }) => (isHeader ? '700' : 'normal')};
  color: white;
`;


const data = [
    { halving: 0, reward: 200, days: 0, cumulativeDays: 0 },
    { halving: 1, reward: 100, days: 7, cumulativeDays: 7 },
    { halving: 2, reward: 50, days: 14, cumulativeDays: 21 },
    { halving: 3, reward: 25, days: 28, cumulativeDays: 49 },
    { halving: 4, reward: 12.5, days: 56, cumulativeDays: 105 },
    { halving: 5, reward: 6.25, days: 112, cumulativeDays: 217 },
    { halving: 6, reward: 3.125, days: 224, cumulativeDays: 441 },
    { halving: 7, reward: 1.5625, days: 448, cumulativeDays: 889 },
  ];

const HalvingTable: React.FC = ({}) => {

  return (
    <TableContainer>
      <Cell isHeader>Halving</Cell>
      <Cell isHeader>SONYC reward</Cell>
      <Cell isHeader>Days</Cell>
      <Cell isHeader>Cumulative Days</Cell>
      {data.map((row, index) => (
        <React.Fragment key={index}>
          <Cell>{row.halving}</Cell>
          <Cell>{row.reward}</Cell>
          <Cell>{row.days}</Cell>
          <Cell>{row.cumulativeDays}</Cell>
        </React.Fragment>
      ))}
    </TableContainer>
  );
}
export default HalvingTable;